export default "__VITE_ASSET__D1bz85Ss__"